/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ManagedServiceName = {
  CodingHarness: "coding_harness",
} as const;
export type ManagedServiceName = ClosedEnum<typeof ManagedServiceName>;

/** @internal */
export const ManagedServiceName$inboundSchema: z.ZodNativeEnum<
  typeof ManagedServiceName
> = z.nativeEnum(ManagedServiceName);
/** @internal */
export const ManagedServiceName$outboundSchema: z.ZodNativeEnum<
  typeof ManagedServiceName
> = ManagedServiceName$inboundSchema;
